// Library imports
import React, { useState } from 'react';
import { styled } from '@mui/material/styles';

// Local imports
import Header from 'components/Common/Header';
import Tab from 'components/Common/Tab';
import { useNavigate } from 'react-router-dom';
import routes from 'constants/routes';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import CreditCardRoundedIcon from '@mui/icons-material/CreditCardRounded';
import BasketAndBalance from 'components/Wallet/BasketAndBalance';
import BankAccountAndDetails from './BankAccountAndDetails';
import WalletInvoices from './WalletInvoices';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

// Styling
const StyledContainer = styled('div')({
    backgroundColor: '#F2F2F6',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
});

const ActionContainer = styled('div')({
    marginBottom: 16,
    padding: 22,
});

const InnerContainer = styled('div')({
    backgroundColor: 'white',
    padding: 4,
    marginTop: 10,
});

interface CardItem {
    title: string;
    description: string;
    label: string;
    icon: React.ReactElement | string;
    balance?: string | number;
}

const CardItems: CardItem[] = [
    {
        title: 'Parish wallet',
        description:
            'This balance is set to automatically withdraw to your linked bank account at the end of each day.You may change this setting by clicking into the details of this balance wallet',
        label: 'wallet',
        icon: <AccountBalanceWalletIcon sx={{ width: 44, height: 44 }} />,
    },
    {
        title: 'Giving Baskets',
        description: 'These are your donation baskets...Need verbiage',
        label: 'givingbaskets',
        icon: <FavoriteRoundedIcon sx={{ width: 44, height: 44 }} fontSize="large" />,
    },
    {
        title: 'Payment Baskets',
        description: 'These are your payment baskets...Need verbiage ',
        label: 'paymentbaskets',
        icon: <CreditCardRoundedIcon sx={{ width: 44, height: 44 }} fontSize="large" />,
    },
];

const Wallet: React.FC = () => {
    const [tab, setTab] = useState('basketsandbalances'); // Set the default tab

    const setTabValue = (value: string) => {
        setTab(value);
    };

    const navigate = useNavigate();

    const navigationHandler = (title: string) => {
        console.log(title + 'inside method');
        if (title === 'Parish wallet') {
            navigate(routes.wallet.parishWallet);
        } else if (title.startsWith('Giving')) {
            navigate(routes.wallet.givingBasket);
        } else {
            navigate(routes.wallet.paymentBasket);
        }
    };

    return (
        <StyledContainer>
            <div style={{ padding: 22 }}>
                <Header />
            </div>
            <ActionContainer>
                <InnerContainer>
                    <Tab
                        tabs={[
                            { value: 'basketsandbalances', label: 'Baskets & Balances' },
                            { value: 'invoices', label: 'Invoices' },
                            { value: 'bankdetails', label: 'Bank Account & Details' },
                        ]}
                        tabValue={tab}
                        setTabValue={setTabValue}
                    />
                    <div>
                        {tab === 'basketsandbalances' ? (
                            <BasketAndBalance navigationHandler={navigationHandler} CardItems={CardItems} />
                        ) : tab === 'invoices' ? (
                            <WalletInvoices />
                        ) : tab === 'bankdetails' ? (
                            <BankAccountAndDetails />
                        ) : null}
                    </div>
                </InnerContainer>
            </ActionContainer>
        </StyledContainer>
    );
};

export default Wallet;
